import { render, staticRenderFns } from "./PuzzleFencesEdit.vue?vue&type=template&id=7673be94"
import script from "./PuzzleFencesEdit.vue?vue&type=script&lang=js"
export * from "./PuzzleFencesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports